import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

interface ScottBikeIconProps extends IconWrapperProps {
  variant?: "light" | "dark";
}

function ScottBikeSvg(props: {
  variant?: "light" | "dark";
  className?: string;
}) {
  const variant = props.variant || "light";
  const mountainFillColor = variant === "light" ? "#FAFAF9" : "#0C0A09";
  const circleFillColor = "#FAFAF9";
  const strokeColor = "#0C0A09";
  const textColor = "#0C0A09";
  return (
    <svg
      className={props.className}
      fill="none"
      role="img"
      viewBox="0 0 18 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>SCOTT Bike</title>
      {/* Mountain shapes */}
      <path
        d="M3.80437 7.25211C3.71816 7.08979 3.66719 6.90503 3.66719 6.70679C3.66719 6.50855 3.71501 6.33212 3.79745 6.17173L5.13461 3.79991C5.13461 3.79991 5.21327 3.6145 5.46938 3.43679C5.72612 3.25908 6.02816 3.26871 6.02816 3.26871L9.34623 3.26999L11.1994 0H4.57835C3.98685 0.00320776 3.46834 0.315002 3.16882 0.785901L0.703392 5.16257C0.36737 5.74189 0.173559 6.41616 0.173559 7.13727C0.173559 7.85837 0.364223 8.52238 0.694583 9.09785V9.10106L3.36515 13.7914L4.98108 10.9635C5.24725 10.4644 5.2548 9.86002 5.00184 9.35511L3.805 7.25211H3.80437Z"
        fill={mountainFillColor}
      />
      <path
        d="M8.93861 9.86498C9.02419 10.0273 9.07516 10.214 9.07516 10.4109C9.07516 10.6079 9.02733 10.7856 8.9449 10.9454L7.60836 13.3185C7.60836 13.3185 7.52907 13.5032 7.27234 13.6809C7.01623 13.858 6.71356 13.849 6.71356 13.849L3.39612 13.8471L1.54359 17.1171H8.16462C8.75613 17.1139 9.27463 16.8014 9.57479 16.3312L12.0402 11.9539C12.3756 11.3746 12.5694 10.7016 12.5694 9.97918C12.5694 9.25679 12.3788 8.59471 12.0478 8.01859V8.01603L9.37783 3.32564L7.7619 6.1536C7.49572 6.65209 7.48817 7.25707 7.74114 7.76197L8.93861 9.86434V9.86498Z"
        fill={mountainFillColor}
      />
      {/* "B" Letter Circle - Always visible with high contrast */}
      <circle
        cx="12.3217"
        cy="13.4619"
        fill={circleFillColor}
        r="5.03814"
        stroke={strokeColor}
        strokeWidth="1"
      />
      <path
        d="M10.3471 15.9792V11.0593H12.7365C13.1407 11.0593 13.4578 11.1744 13.6881 11.4047C13.9183 11.6349 14.0335 11.9404 14.0335 12.321C14.0335 12.57 13.9912 12.7721 13.9066 12.9272C13.8267 13.0775 13.7163 13.188 13.5753 13.2585C13.439 13.3289 13.2863 13.3689 13.1172 13.3783V13.4206C13.2346 13.4206 13.3568 13.4417 13.4837 13.484C13.6106 13.5263 13.7304 13.5921 13.8432 13.6814C13.9559 13.7707 14.0476 13.8905 14.1181 14.0408C14.1885 14.1865 14.2238 14.3651 14.2238 14.5765C14.2238 14.835 14.1674 15.0699 14.0546 15.2814C13.9465 15.4928 13.7962 15.662 13.6035 15.7889C13.4155 15.9158 13.1994 15.9792 12.955 15.9792H10.3471ZM11.4185 13.9492V15.077H12.652C12.7459 15.077 12.8258 15.0605 12.8916 15.0276C12.9621 14.99 13.0161 14.9384 13.0537 14.8726C13.0913 14.8068 13.1101 14.7269 13.1101 14.6329V14.3933C13.1101 14.2993 13.0913 14.2194 13.0537 14.1536C13.0161 14.0878 12.9621 14.0385 12.8916 14.0056C12.8258 13.968 12.7459 13.9492 12.652 13.9492H11.4185ZM11.4185 11.9615V13.0752H12.4828C12.5768 13.0752 12.6567 13.0587 12.7224 13.0259C12.7929 12.9883 12.8446 12.9366 12.8775 12.8708C12.9151 12.8003 12.9339 12.7181 12.9339 12.6241V12.4126C12.9339 12.3186 12.9151 12.2388 12.8775 12.173C12.8446 12.1025 12.7929 12.0508 12.7224 12.0179C12.6567 11.9803 12.5768 11.9615 12.4828 11.9615H11.4185Z"
        fill={textColor}
      />
    </svg>
  );
}

export function IconScottBike(props: ScottBikeIconProps) {
  return (
    <IconWrapper {...props}>
      <ScottBikeSvg className={props.className} variant={props.variant} />
    </IconWrapper>
  );
}
